function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "target");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14.667 2.667v2.76c-4.827 0.613-8.627 4.413-9.24 9.24h-2.76v2.667h2.76c0.613 4.827 4.413 8.627 9.24 9.24v2.76h2.667v-2.76c4.827-0.613 8.627-4.413 9.24-9.24h2.76v-2.667h-2.76c-0.613-4.827-4.413-8.627-9.24-9.24v-2.76zM14.667 8.107v2.56h2.667v-2.547c3.333 0.547 6 3.213 6.56 6.547h-2.56v2.667h2.547c-0.547 3.333-3.213 6-6.547 6.56v-2.56h-2.667v2.547c-3.333-0.547-6-3.213-6.56-6.547h2.56v-2.667h-2.547c0.547-3.333 3.213-6 6.547-6.56zM16 14.667c-0.733 0-1.333 0.6-1.333 1.333s0.6 1.333 1.333 1.333c0.733 0 1.333-0.6 1.333-1.333s-0.6-1.333-1.333-1.333z"
});

var SvgTarget = function SvgTarget(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTarget, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/target.c00458c1.svg";
export { ForwardRef as ReactComponent };